import debounce from "lodash.debounce";
import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";
import deliveryDateClass from "./delivery-date-class";
import { CachedDeliveryManager } from "./cached-delivery-manager";

export class DeliveryDateFormClass {
  #debounceDelay = 2000;

  #inputSelector = ".js-delivery-zipcode";

  #errorCallback;

  constructor(errorCallback) {
    this.#errorCallback = errorCallback;
  }

  get #$input() {
    return document.querySelector(this.#inputSelector);
  }

  static #trackZipCodeSubmit(zipcode, successful) {
    track("section_delivery_zipcode_changed", {
      target: "Delivery Date",
      zipcode,
      is_successful: successful
    });
  }

  #setInputError(hasError) {
    this.#$input.classList.toggle("error", hasError);

    if (this.#errorCallback) {
      this.#errorCallback(hasError);
    }
  }

  async #refreshDeliveryDate(zipcode) {
    const oldZipcode = document.documentElement.dataset.zipcode;
    document.documentElement.dataset.zipcode = zipcode;
    this.#setInputError(false);

    try {
      // Update cached delivery date for the new zipcode
      await CachedDeliveryManager.updateCachedDeliveryDate();

      await deliveryDateClass().init(() => {
        document.dispatchEvent(
          new CustomEvent("zipcode-location-updated", {
            detail: { zipcode, oldZipcode }
          })
        );
      });

      DeliveryDateFormClass.#trackZipCodeSubmit(zipcode, true);
    } catch (error) {
      this.#setInputError(true);
      DeliveryDateFormClass.#trackZipCodeSubmit(zipcode, false);
    }
  }

  init(isUsZipcode = false) {
    const $input = this.#$input;
    if (!$input) return;

    const loadZipcode = debounce(e => {
      this.#refreshDeliveryDate(e.target.value);
    }, this.#debounceDelay);

    onEvent("input", this.#inputSelector, e => {
      const zipcode = e.target.value;

      if (isUsZipcode) {
        if (zipcode && zipcode.length >= 5) {
          loadZipcode(e);
        }
      } else {
        loadZipcode(e);
      }
    });

    onEvent("keydown", this.#inputSelector, e => {
      if (e.key === "Enter") {
        loadZipcode.cancel();
        this.#refreshDeliveryDate(e.target.value);
      }
    });
  }
}

export default errorCallback => new DeliveryDateFormClass(errorCallback);
